export enum ProductType {
	Internet,
	Phone,
	Mobile,
	Tv,
	Virtual,
	PhoneNumber,
	Discount,
	SIPTrunk,
	TelephoneSystem,
	Conference,
	Fax,
	VoiceChannel,
	NewPhoneNumberBlock,
	PortedPhoneNumberBlock,
	TopStop,
	ClipNoScreening,
	Fax2Mail,
	TelephoneSystemParticipant,
	MinutePackage,
	Router,
	Software,
	EMail,
}